export function toAsset(path: string) {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  } else {
    return `https://assets.birdie.com.br/${path}`
  }
}
